import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import { Box } from 'ui';

import { ZoomControlGroupButton } from '../Buttons/ZoomControlGroupButton';
import { useMap } from '../context/useMapContext';

type ZoomControlProps = {
  controlPosition: ControlPosition;
};

const ZoomControl = ({ controlPosition }: ZoomControlProps) => {
  const { handleZoomUpdate } = useMap();

  return (
    <MapControl position={controlPosition}>
      <Box p="md">
        <ZoomControlGroupButton onChange={handleZoomUpdate} />
      </Box>
    </MapControl>
  );
};

export { ZoomControl };
